import localConfig from "../../../../config/local-config";

const getRedirectUri = () => {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/myaccount/login`;
  }

  return '';
};

const getScopes = () => {
  return [
    'https://www.googleapis.com/auth/userinfo.email',
    'https://www.googleapis.com/auth/userinfo.profile',
    'openid',
  ];
};

const oauthConfig = () => {
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    const isTrackPackagePage = window.location.pathname === '/myaccount/trackpackage';

    const isCartPage = window.location.pathname === '/cart';

    let stateString = '';
    if (isTrackPackagePage || isCartPage) {
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.delete('referer');
      const paramStr = currentParams.toString();
      stateString = window.location.pathname + (paramStr ? `?${paramStr}` : '');
    } else {
      const referer = params.get('referer');
      stateString = referer || '';
    }

    const options = {
      redirect_uri: getRedirectUri(),
      client_id: localConfig?.googleClientId,
      access_type: 'offline',
      response_type: 'code',
      prompt: 'consent',
      state: stateString,
      scope: getScopes().join(' '),
    };

    return {
      url: 'https://accounts.google.com/o/oauth2/auth',
      options,
    };
  }
  return {
    url: '',
    options: null,
  };
};

export { oauthConfig, getRedirectUri };
